import React, {Component} from 'react';
import "../../../asset/style/neotileviewer/slide_meta_app.css"
import {
	Button,
	Chip,
	Divider,
	IconButton,
	MenuItem,
	Paper,
	Popper,
	Select,
	Stack,
	Tooltip,
	Typography
} from "@mui/material";
import {connect} from "react-redux";
import {StyledSwitch} from "../components/StyledComponents";
import {
	toggleTileMap,
	updateSelectedTileColor,
	updateSelectedTileSize
} from "../../../redux_actions/gamma.state.action";
import TileLayers from "../tileLayers/TileLayers";
import {Loader, TiledStatus, TileViewerConstants} from "../../../utils/const";
import CircleIcon from "@mui/icons-material/Circle";
import cookie from "react-cookies";
import {isNull} from "../../../utils/utils";
import {isOpenLayersMap} from "../utils/map_utils";
import {Loading, LoadingText} from "../components/components";
import RefreshIcon from "@mui/icons-material/Refresh";
import {initSlide} from "../../../redux_actions/maps.state.action";
import {notifyError, notifySuccess} from "../utils/display.notification";
import PathForMask from "../tileLayers/PathForMask";
import HistogramTXTY from "../tileLayers/HistogramTXTY";
import {get_response} from "../../../helper/request";


class TileViewApp extends Component {

	constructor(props) {
		super(props);

		this.state = {
			pathMask: false,
		}
		this.ref = React.createRef();
	}

	/** OpenSeadragon has no getTarget(); after a switch, also wait until the OL map has its target. */
	isOlMapReady = (slidemap) => isOpenLayersMap(slidemap) && !isNull(slidemap.getTarget());

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.isOlMapReady(prevProps.slidemap) !== this.isOlMapReady(this.props.slidemap) ||
			prevProps.slidemap !== this.props.slidemap) {
			this.forceUpdate();
		}
	}

	toggle = () => this.props.dispatch(toggleTileMap(!this.props.tileMapEnable));

	changeTextColor = e => this.props.dispatch(updateSelectedTileColor(e.target.value));

	getColorDropBarComponent = () =>
		<Tooltip placement={"bottom"}>
			<Select variant={"filled"} value={this.props.selectedTileColor?.toLowerCase()}
					onChange={(e) => this.changeTextColor(e)}>
				{Object.values(TileViewerConstants.TEXT_COLORS).map(color =>
					<MenuItem value={color.toLowerCase()}>
						<CircleIcon sx={{color: color.toLowerCase()}}/>
					</MenuItem>)}
			</Select>
		</Tooltip>;

	changeTextSize = e => this.props.dispatch(updateSelectedTileSize(e.target.value));

	getTextDropBarComponent = () =>
		<Tooltip placement={"bottom"}>
			<Select variant={"filled"} value={this.props.selectedTileSize}
					onChange={(e) => this.changeTextSize(e)}>
				{Object.values(TileViewerConstants.TEXT_SIZE).map(size =>
					<MenuItem value={size}>
						{size}
					</MenuItem>)}
			</Select>
		</Tooltip>;

	tiling = () => {
		let {slide, activeMapId} = this.props;
		let {morphle_id, id} = slide;
		let url = `/server/start_tiling/?morphle_id=${morphle_id}`;
		get_response(url)
			.then(() => {
				this.props.dispatch(initSlide(activeMapId, id));
				notifySuccess('tiling_started', `Tiling Started For: ${morphle_id}`);
			})
			.catch(err => {
				notifyError('tiling_error', "Error. Could not schedule for tiling.");
			});
	}

	refreshSlide = () => this.props.dispatch(initSlide(this.props.activeMapId, this.props.slide.id));

	getTilingComponent = () => {
		let {slide} = this.props;
		let tilingStatus = slide.tiling_status;
		if (cookie.loadAll().superuser === "true") {
			if (tilingStatus === 2) {
				return <Stack direction={"row"} alignItems="center" justifyContent={"space-between"}>
					<Typography sx={{fontWeight: 700}}>Enable</Typography>
					<StyledSwitch color={"secondary"} checked={this.props.tileMapEnable} onChange={this.toggle}/>
				</Stack>
			} else if (tilingStatus === 100) {
				return <div key="2">Error occured while Tiling. Check Jenkins 'raw-tiling'.</div>
			} else {
				return <Stack direction={"row"} alignItems="center" justifyContent={"space-between"}>
					<Chip label={TiledStatus[tilingStatus]} size={"small"} sx={{width: "70%", borderRadius: 0}}
						  color={"secondary"} disabled={tilingStatus !== 0} onClick={this.tiling}/>
					<IconButton onClick={this.refreshSlide} color={"secondary"}><RefreshIcon/></IconButton>
					<StyledSwitch color={"secondary"} checked={this.props.tileMapEnable} onChange={this.toggle}/>
				</Stack>
			}
		}
	}

	togglePathMaskImg = () => {
		this.setState({
			pathMask: !this.state.pathMask
		});
	}

	render() {
		let {slide} = this.props;
		if(isNull(slide)) return <Loading/>
		let scanFolderUrl = "app://" + slide.loc_on_machine + "/scans/" + slide.bucket_name + "/" + slide.path;

		if (this.props.loadingState.loading) {
			return <Loader/>
		}
		// returning cause data is critical
		if (!this.isOlMapReady(this.props.slidemap)) return <LoadingText/>;
		return (
			<Stack direction={"column"} spacing={1} ref={this.ref}>
				<Typography variant={"caption"} align={"center"} sx={{fontSize: "10px"}}>
					<a href={scanFolderUrl}>{this.props.slide.morphle_id}</a>
				</Typography>
				{this.getTilingComponent()}
				<Divider/>
				<Typography>
					Text Color : {this.getColorDropBarComponent()}
					Text Size : {this.getTextDropBarComponent()}
				</Typography>
				<Divider/>
				<>
					<Button color={"secondary"} variant={"outlined"} size={"small"}
							style={{textTransform: 'capitalize'}} onClick={this.togglePathMaskImg}>
						Open PathForMask Image
					</Button>
					<Popper placement="right" open={this.state.pathMask}>
						<Paper elevation={3}
							   sx={{height: "700px", width: "600px", marginTop: "50px", marginLeft: "50px"}}>
							<PathForMask onImageClose={this.togglePathMaskImg} slide={this.props.slide}/>
						</Paper>
					</Popper>
				</>
				<HistogramTXTY slide={this.props.slide} activeMapId={this.props.activeMapId}/>
				<Divider/>{
				this.props.tileMapEnable &&
				<TileLayers map={this.props.slidemap} slide={this.props.slide}
							rescanThreshValue1={this.props.rescanThreshValue1}
							rescanThreshValue2={this.props.rescanThreshValue2}
							textColor={this.props.selectedTileColor} textSize={this.props.selectedTileSize}
							tileMapEnable={this.props.tileMapEnable}
							tileViewerState={this.props.morpheusSetting.tile_viewer_app_state}/>}
			</Stack>
		);
	}
}

const mapStateToProps = (state) => {
	let {
		activeMapId,
		tileMapEnable,
		selectedTileColor,
		selectedTileSize,
		rescanThreshValue1,
		rescanThreshValue2
	} = state.gammaStateReducer;
	let {slide, slidemap} = state.mapsStateReducer[activeMapId] || {};
	let morpheusSetting = state.morpheusSettingReducer;
	let loadingState = state.slideLoadingReducer;


	return {
		slide,
		activeMapId,
		tileMapEnable,
		slidemap,
		selectedTileColor,
		selectedTileSize,
		rescanThreshValue1,
		rescanThreshValue2,
		morpheusSetting,
		loadingState
	};
}

export default connect(mapStateToProps)(TileViewApp)
